const MasterUserTipi = {
    1: "Süper Yönetici",
    2: "Tenant Yönetici",
}

export default MasterUserTipi;
